export default __webpack_public_path__ + "static/media/rt-team-3-anthony.aa773bbd.png";